module.exports = __webpack_public_path__ + "static/media/Armand.f0803fb6.jpeg";